import React from 'react';
import BreadCrumb from 'Common/BreadCrumb';
import WarrantyTypesCRUD from './WarrantyTypes';

const ExpenseCategory = () => {
    return (
        <React.Fragment>
            <div className="container-fluid group-data-[content=boxed]:max-w-boxed mx-auto">
                <BreadCrumb title='Listado de Tipos de Garantias' pageTitle='Tipos de Garantias' />
                <WarrantyTypesCRUD />
            </div>
        </React.Fragment>
    )
}

export default ExpenseCategory;